import { logDispatcher } from 'src/app/core/decorators/state.decorators';
import {
  AttendanceCAU,
  AttendanceCAUFile,
  AttendanceCauFileRequest,
  AttendanceCauRequest,
} from '../../models/attendance-cau.model';
import { MassiveResponse } from 'src/app/modules/massive-actions/models/massive.model';
import { StudentsAttendances } from '../../models/student-attendance.model';

export namespace AttendanceActions {
  @logDispatcher
  export class GetStudentAttendances {
    static readonly type = '[Attendance] GetStudentAttendances';
    constructor() {}
  }

  @logDispatcher
  export class GetStudentAttendancesSuccess {
    static readonly type = '[Attendance] GetStudentAttendancesSuccess';
    constructor(public studentsAttendances: StudentsAttendances) {}
  }

  @logDispatcher
  export class GetAttendanceCau {
    static readonly type = '[Attendance] GetAttendanceCau';
    constructor(public attendanceCAUFileId: string, public exerciseId: number) {}
  }

  @logDispatcher
  export class GetAttendanceCauSuccess {
    static readonly type = '[Attendance] GetAttendanceCauSuccess';
    constructor(public attendancesCAUResponse: AttendanceCAU, public exerciseId: number) {}
  }

  @logDispatcher
  export class GetAttendancesCau {
    static readonly type = '[Attendance] GetAttendancesCau';
    constructor(public exerciseId: number, public year: number, public month: number, public user: string) {}
  }
  

  @logDispatcher
  export class GetAttendancesCauSuccess {
    static readonly type = '[Attendance] GetAttendancesCauSuccess';
    constructor(public attendanceCAUFiles: AttendanceCAUFile[]) {}
  }

  @logDispatcher
  export class UpdateStudentAttendanceMassive {
    static readonly type = '[Attendance] UpdateStudentAttendanceMassive';
    constructor(public user: string) {}
  }

  @logDispatcher
  export class UpdateStudentAttendanceMassiveSuccess {
    static readonly type = '[Attendance] UpdateStudentAttendanceMassiveSuccess';
    constructor(public massiveResponse: MassiveResponse) {}
  }

  @logDispatcher
  export class UpdateAttendanceCauMassive {
    static readonly type = '[Attendance] UpdateAttendanceCauMassive';
    constructor(public attendanceCAUFileId: string, public user: string) {}
  }

  @logDispatcher
  export class UpdateAttendanceCauMassiveSuccess {
    static readonly type = '[Attendance] UpdateAttendanceCauMassiveSuccess';
    constructor(public massiveResponse: MassiveResponse) {}
  }

  @logDispatcher
  export class UpdateAttendanceCAU {
    static readonly type = '[Attendance] UpdateAttendanceCAU';
    constructor(public studentId: number, public index: number, public user: string) {}
  }

  @logDispatcher
  export class UpdateAttendanceCAUSuccess {
    static readonly type = '[Attendance] UpdateAttendanceCAUSuccess';
    constructor(public index: number) {}
  }

  @logDispatcher
  export class UpdateStudentAttendance {
    static readonly type = '[Attendance] UpdateStudentAttendance';
    constructor(public studentId: number, public index: number, public user: string) {}
  }

  @logDispatcher
  export class UpdateStudentAttendanceSuccess {
    static readonly type = '[Attendance] UpdateStudentAttendanceSuccess';
    constructor(public index: number) {}
  }

  @logDispatcher
  export class ValidateAttendanceSchool {
      static readonly type = '[Attendance] ValidateAttendanceSchool';
      constructor(public user: string) { }
  }

  @logDispatcher
  export class ValidateAttendanceSchoolSuccess {
      static readonly type = '[Attendance] ValidateAttendanceSchoolSuccess';
      constructor() { }
  }

  @logDispatcher
  export class SetDaysInMonth {
    static readonly type = '[Attendance] SetDaysInMonth';
    constructor(public year: number, public month: number) {}
  }

  @logDispatcher
  export class SetFileExercise {
    static readonly type = '[Attendance] SetFileExercise';
    constructor(public exerciseId: number) {}
  }

  @logDispatcher
  export class SetOriginalAttendanceDays {
    static readonly type = '[Attendance] SetOriginalAttendanceDays';
    constructor(public studentId: number) {}
  }

  @logDispatcher
  export class SetProposalAttendanceDays {
    static readonly type = '[Attendance] SetProposalAttendanceDays';
    constructor(public studentId: number) {}
  }


  @logDispatcher
  export class SetShowNoBillable {
    static readonly type = '[Attendance] SetShowNoBillable';
    constructor(public showNoBillable: boolean) {}
  }

  @logDispatcher
  export class SetIsListSmaller {
    static readonly type = '[Attendance] SetIsListSmaller';
    constructor(public isListSmaller: boolean) {}
  }

  @logDispatcher
  export class EditTableCell {
    static readonly type = '[Attendance] EditTableCell';
    constructor(public index: number, public day: number, public newValue: number) {}
  }

  @logDispatcher
  export class EditTableCellCau {
    static readonly type = '[Attendance] EditTableCellCau';
    constructor(public index: number, public day: number, public newValue: number) {}
  }

  @logDispatcher
  export class SetReloadData {
    static readonly type = '[Attendance] SetReloadData';
    constructor(public value: boolean) {}
  }

  @logDispatcher
  export class SetIsLoading {
    static readonly type = '[Attendance] SetIsLoading';
    constructor(public value: boolean) {}
  }

  @logDispatcher
  export class LoadAttendanceCauFile {
      static readonly type = '[Attendance] LoadAttendanceCauFile';
      constructor(public user: string, public attendanceCauFileRequest: AttendanceCauFileRequest) { }
  }

  @logDispatcher
  export class LoadAttendanceCauFileSuccess {
      static readonly type = '[Attendance] LoadAttendanceCauFileSuccess';
      constructor() { }
  }

  @logDispatcher
  export class SetDefaultState {
      static readonly type = '[Attendance] SetDefaultState';
      constructor() { }
  }

  @logDispatcher
  export class SetValidateAttendanceFormDefaultState {
    static readonly type = '[Attendance] SetValidateAttendanceFormDefaultState';
    constructor() {}
  }

  @logDispatcher
  export class SetAttendanceCauRequestDefault {
    static readonly type = '[Attendance] SetAttendanceCauRequestDefault';
    constructor(public attendanceCauRequest: AttendanceCauRequest) {}
  }

  @logDispatcher
  export class SetAttendanceCauFileAddDefault {
    static readonly type = '[Attendance] SetAttendanceCauFileAddDefault';
    constructor() {}
  }

  @logDispatcher
  export class SetAttendanceCAUDefaultState {
    static readonly type = '[Attendance] SetAttendanceCAUDefaultState';
    constructor() {}
  }

  @logDispatcher
  export class Error {
      static readonly type = '[Attendance] Error';
      constructor(public error: any, public details: string) { }
  }
}
